import type { Message } from '@magic/schemas/messages';
import { RoundedIcon, Tooltip } from '@resultadosdigitais/tangram-components';
import { ThumbsDown, ThumbsUp } from '@resultadosdigitais/tangram-react-icons';
import styled from 'styled-components';

import { empty } from '@exact-magic/utils';
import { useChat } from '../context/chat';

const FeedbackContainer = styled.div`
  display: flex;
  gap: var(--size-spacing-02);
`;

const FeedbackIcon = styled(RoundedIcon)<{ disabled: boolean }>`
  cursor: default;
  ${({ disabled }) => (disabled ? 'cursor: default;' : 'cursor: pointer;')}
`;

const options = [
  {
    value: true,
    text: 'Esta resposta parece correta',
    icon: ThumbsUp,
  },
  {
    value: false,
    text: 'Esta resposta parece incorreta',
    icon: ThumbsDown,
  },
];

export type FeedbackProps = {
  message: Message;
};

export const Feedback = ({
  message: { id, role, feedback, metadata = {} },
}: FeedbackProps) => {
  const { handleFeedback } = useChat();

  if (role !== 'assistant' || metadata.welcome) {
    return null;
  }

  return (
    <FeedbackContainer>
      {options.map(({ value, text, icon: Icon }) => {
        return (
          <Tooltip
            key={`message-like-${value}-${id}`}
            text={text}
            position={Tooltip.positions.RIGHT}
          >
            <FeedbackIcon
              fill={
                value === feedback
                  ? 'var(--neutral-surface-high-emphasis)'
                  : 'var(--neutral-surface)'
              }
              size={RoundedIcon.sizes.xs}
              onClick={async () => {
                handleFeedback!({
                  id,
                  feedback: feedback === value ? null : value,
                });
              }}
            >
              <Icon fill={'var(--neutral-icon-low-emphasis)'} title={text} />
            </FeedbackIcon>
          </Tooltip>
        );
      })}
    </FeedbackContainer>
  );
};
